import { Stack } from "@mui/material";

import agalarov from "./assets/agalarov.svg";
import seabreeze from "./assets/seabreeze.svg";
import { Image } from "../../../fe-ui/atoms/Image";
export const LandingAgalarovLogos = () => {
  return (
    <Stack direction={"row"} spacing={4} my={2} justifyContent={"center"} alignItems={"center"} py={2}>
      <Image draggable={false} src={seabreeze.src} />
      <Image draggable={false} src={agalarov.src} />
    </Stack>
  );
};
